import React from 'react';
import { useConnect } from '@lore/query-connect';

export default function Header(props) {
  const { organization } = props;

  return (
    <div className="flex flex-col space-y-2">
      <div className="space-y-0.5">
        <div className="text-lg font-semibold text-cs-gray-900">
          {organization.data.name}
        </div>
        <div className="text-base text-cs-gray-500 line-clamp-3">
          {organization.data.addressLine1}, {organization.data.city}, {organization.data.state}
        </div>
      </div>
    </div>
  );
}
